module.exports = __webpack_public_path__ + "img/122.6402a214.webp";